@if (data$ | async; as data) {
  <header class="relative z-10 bg-gray-600 bg-opacity-40 p-6 flex" (window:resize)="onResize($event)" [style]="showNav() ? 'position: fixed !important; top: 0; left: 0; --tw-bg-opacity: 0.95 !important; width: 100vw; height: 100vh; z-index: 20 !important' : ''">
    <div class="container mx-auto lg:flex items-center justify-between md:flex-wrap">
      <a routerLink="/" class="prose cursor-pointer flex items-center flex-no-shrink text-white mr-3 lg:mr-9 text-yellow-200 hover:text-red-600 no-underline">
        @if (site()?.logo?.url) {
        <img
          [src]="site()?.logo?.url"
          [alt]="site()?.title"
          [attr.width]="site()?.logo?.width"
          [attr.height]="site()?.logo?.height"
          class="mb-0 mr-2 lg:mr-4"
        />
        }
        <h1 class="text-lg md:text-xl uppercase text-white m-0">{{ site()?.title }}</h1>
      </a>

      <nav class="w-full flex-grow hidden lg:flex lg:items-center lg:w-auto mt-10 lg:mt-0" [class.block]="showNav()" [class.text-center]="showNav()">
        <div class="text-sm lg:flex-grow">
          @for (item of (data?.length > 2 ? data.slice(1, data.length - 1) : []); track item) {
            <a [routerLink]="item.name" (click)="closeNav()" class="block mt-4 lg:inline-block lg:mt-0 text-yellow-200 hover:text-blue-600 lg:mr-4 uppercase no-underline">{{ item.title }}</a>
          }
        </div>
        @if (data?.length) {
          <a [routerLink]="data[data.length - 1].name" class="inline-block text-sm px-4 py-2 leading-none border rounded text-white border-white hover:border-blue-600 hover:text-blue-600 mt-4 lg:mt-0 uppercase no-underline">{{ data[data.length - 1].title }}</a>
        }
      </nav>
    </div>

    <div class="absolute top-7 right-3 md:top-12 md:right-5 lg:hidden">
      <button (click)="toggleNav()" class="self-start flex items-center px-3 py-2 text-yellow-200 border-yellow-300 hover:text-white hover:border-white">
        <svg class="w-6 h-4 fill-current text-yellow-200" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><title>Menu</title><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
      </button>
    </div>
  </header>
}
